import axios from 'axios'
import { REACT_APP_API } from '../../config'

export async function getCampaignExcel(campaignId) {
  try {
    const { data } = await axios.get(`${REACT_APP_API}/leads/campaign/getCampaignExcel`, {
      params: { campaignId },
    })
    return data
  } catch (error) {
    throw new Error(error)
  }
}
